import {
  Component,
  computed,
  Directive,
  inject,
  input,
  Input,
  output,
  TemplateRef,
} from '@angular/core';
import { CollectionFilterDefinition, CollectionFilterDirectiveInterface } from './filter.models';
import { COLLECTION_TABLE_FILTER_PROVIDER } from './filter.provider';

@Directive({
  standalone: true,
  selector: '[collectionTableFilter]',
})
export class CollectionTableFilterDirective {
  @Input('collectionTableFilter') public filter: string;
  public templateRef = inject(TemplateRef);
}

@Component({
  standalone: true,
  selector: 'collection-table-filter-base',
  template: ``,
})
export class CollectionTableFilterBaseComponent implements CollectionFilterDirectiveInterface {
  provider = inject(COLLECTION_TABLE_FILTER_PROVIDER);
  event = output<{ type: string; data?: any }>();
  definition = input<CollectionFilterDefinition>();
  state = input<{ [field: string]: any }>({});
  query = input<{ [field: string]: any }>({});
  value = computed(() => {
    const _state = this.state();
    const _definition = this.definition();
    if (!_definition || !_state) {
      return null;
    }
    return _state[_definition.key] || null;
  });

  private _disabled: boolean;

  set disabled(disabled: boolean) {
    this._disabled = disabled;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }

  get valid() {
    return true;
  }

  get invalid() {
    return !this.valid;
  }

  // getPayload() {
  //   return {};
  // }

  getQuery() {
    return {};
  }

  handleValueChanged = () => {
    this.event.emit({
      type: 'change',
      data: this.getQuery(),
    });

    this.provider.updateState(this.definition(), this.getQuery());
  };

  // static fromQuery(response: any, definition: CollectionFilterDefinition): { [key: string]: any } {
  //   console.error('Not implemented', this.constructor.name, 'fromQuery', response, definition);
  //   return {};
  // }
}
